/** Fonte do registro de execução do Genesis — a mesma frase em todo o site (Home, Casos, cartão de prova). */
export const FONTE_EXEC = { label: 'Zentriz · execução real do Genesis, registrada em agosto/2026 (identificadores internos ocultados)' }
